export default "__VITE_ASSET__CigUost4__"